// @core/api/endpoints/chat/get_unread_counts.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUnreadCountsResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Get unread counts
 * Returns unread message counts and mention counts for all conversations the user is a member of. Used for displaying notification badges.
 */
export async function GetUnreadCounts(
  params?: {
  },
  options?: RequestOptions
): Promise<GetUnreadCountsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/conversations/unread`;
  const requestOptions = options;
  return client.get<GetUnreadCountsResponse>(requestPath, { ...requestOptions, params });
}
